"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Create = void 0;
var react_1 = __importDefault(require("react"));
var structure_1 = require("remota-client/component/structure");
var panel_1 = require("remota-client/component/panel");
var Create = function (props) {
    return (react_1.default.createElement(structure_1.PlainStructure, { center: true },
        react_1.default.createElement(panel_1.LogoPanel, { width: 720 }, "URL\u304C\u9593\u9055\u3063\u3066\u3044\u308B\u304B\u3001\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u307E\u3059")));
};
exports.Create = Create;
